import { useState } from 'react';
import { stopAll } from '../shared/events';
import { addFavorite, deleteFavorite } from '../shared/api_request_helpers';

export default function FavoriteToggle({listing: {id}, favorite: initialFavorite}) {
  const [favorite, setFavorite] = useState(initialFavorite);
  const persistFavorite = (favorite) => {
    if (favorite) {
      addFavorite(id)
    } else {
      deleteFavorite(id);
    }
  };
  const toggleFavorite = () => {
    setFavorite(!favorite);
    persistFavorite(!favorite);
  };
  return (
    <i className={favorite ? "icon-heart" : "icon-heart-empty"}
      title={favorite ? "Remove from your stable" : "Add to your stable"}
      onClick={stopAll(toggleFavorite)} />
  );
}
